<script setup>

import {ref, watch} from "vue";

const props = defineProps({
  show: Boolean,
})

const emit = defineEmits([
    "close",
    "login",
])

const userName = ref("")
const password = ref("")

watch(
    () => props.show,
    (newVal) => {
      if (!newVal) {
        clearUserLoginInfo()
      }
    }
)

const close = () => {
  clearUserLoginInfo()
  emit("close")
}

const login = () => {
  const sendUserName = userName.value
  const sendPassword = password.value
  emit("login", sendUserName, sendPassword)
}

const clearUserLoginInfo = () => {
  userName.value = ""
  password.value = ""
}

</script>

<template>
  <Transition name="fade">
    <div v-if="props.show" class="login-overlay" @click.self="close">
      <div class="lambo-blue-card-large">
        <div class="neon-line-top"></div>
        <button class="btn-cancel-top" @click="close">×</button>
        <div class="lambo-header">
          <h2>アカウントログイン</h2>
          <p class="sub-title">AUTHENTICATION REQUIRED</p>
          <div class="blue-accent-long"></div>
        </div>
        <div class="lambo-body">
          <div class="input-group">
            <label class="hud-label">アカウントID</label>
            <div class="lambo-input-container">
              <input v-model="userName" type="text" placeholder="IDを入力" autocomplete="off"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="input-group">
            <label class="hud-label">パスワード</label>
            <div class="lambo-input-container">
              <input v-model="password" type="password" placeholder="パスワードを入力"
                     @keyup.enter="login"
                     autocomplete="off"
              />
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        <div class="lambo-footer">
          <button class="btn-lambo-engine" @click="login">ログイン</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.login-overlay {
  position: fixed;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(4, 8, 26, 0.7);
  backdrop-filter: blur(15px);

  z-index: 9999;
}

.lambo-blue-card-large {
  width: 480px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid rgba(0, 102, 255, 0.18);
  padding: 48px 56px;
  color: #1e293b;

  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12),
  0 8px 24px rgba(0, 102, 255, 0.08);

  border-radius: 20px;

  position: absolute;
  top: 50%;
  left: 50%;

  /* 关键修正 */
  transform: translate(-50%, -50%);
}


.neon-line-top {
  height: 3px;
  background: linear-gradient(
      90deg,
      transparent,
      #0066ff,
      transparent
  );
  box-shadow: none;
}

.lambo-header h2 {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.5px;
}

.sub-title {
  font-size: 11px;
  color: #64748b;
  letter-spacing: 2px;
}

.blue-accent-long {
  background: #0066ff;
  box-shadow: none;
}

.hud-label {
  display: block;
  font-size: 11px;
  color: #00D1FF;
  margin-bottom: 12px;
  letter-spacing: 2px;
  font-weight: 600;
  text-transform: uppercase;
}

.lambo-input-container {
  position: relative;
  margin-bottom: 20px;
}

.lambo-input-container input {
  background: #ffffff;
  border: 1px solid #dbeafe;
  color: #1e293b;
  font-size: 15px;
  border-radius: 10px;
  padding: 14px 16px;
  width: 100%;
}

.lambo-input-container input::placeholder {
  color: #94a3b8;
}

.input-glow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #00D1FF;
  transition: 0.4s ease-out;
}

.lambo-input-container input:focus {
  border-color: #0066ff;
  box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.12);
  background: #ffffff;
}

.btn-lambo-engine {
  width: 100%;
  padding: 16px;
  background: linear-gradient(
      180deg,
      #2f7bff 0%,
      #0055e6 100%
  );
  border: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2px;
  border-radius: 12px;
  cursor: pointer;

  box-shadow: 0 12px 30px rgba(0, 102, 255, 0.28);
  transition: all 0.25s ease;
}

.btn-lambo-engine:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 40px rgba(0, 102, 255, 0.35);
}

.btn-cancel-top {
  position: absolute;
  top: 20px;
  right: 30px;
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 24px;
  cursor: pointer;
}

</style>
